// response error
// @FILE src/utils/response-error.ts
// @AUTHOR CAIHUAZHI <huazhi.chz@alibaba-inc.com>
// @CREATE 2021/12/28 10:04
export class ResponseError {
    constructor(message, status, response) {
        this.className = 'ResponseError';
        this.message = message;
        this.status = status;
        this.response = response;
    }
    toString() {
        return this.message;
    }
}
ResponseError.displayName = 'ResponseError';
